/**
 * External Waypoint web properties.
 *
 * These live outside the app bundle (separate static sites / subdomains), so
 * they're referenced by absolute URL and open in a new tab. Override per
 * environment via the matching VITE_* env var; otherwise the production
 * default is used. Mirrors the VITE_API_URL fallback pattern in lib/api.ts.
 */

/** Public help center (browsable articles + search). */
export const HELP_CENTER_URL =
  import.meta.env.VITE_HELP_URL ?? 'https://help.waypoint-intel.com';
